<template>
  <div class="agent-designer">
    <VueFlow
      :nodes="nodes"
      :edges="edges"
      :nodes-draggable="false"
      :nodes-connectable="false"
      :elements-selectable="false"
      :edges-updatable="false"
      :zoom-on-double-click="false"
      :pan-on-drag="true"
      :zoom-on-scroll="true"
      :min-zoom="0.3"
      :max-zoom="1.5"
    >
      <template #node-container="{ data }"><GroupNode :data="data" /></template>
      <template #node-agent="{ data }"><AgentNode :data="data" /></template>
      <template #node-config="{ data }"><ConfigNode :data="data" /></template>
      <template #node-tool="{ data }"><ToolNode :data="data" /></template>
    </VueFlow>
  </div>
</template>

<script>
import { VueFlow, useVueFlow } from '@vue-flow/core';
import '@vue-flow/core/dist/style.css';
import '@vue-flow/core/dist/theme-default.css';
import './agent-designer.css';
import buildGraph from './graph';
import AgentNode from './nodes/AgentNode.vue';
import ConfigNode from './nodes/ConfigNode.vue';
import ToolNode from './nodes/ToolNode.vue';
import GroupNode from './nodes/GroupNode.vue';

export default {
  name: 'AgentDesigner',
  components: { VueFlow, AgentNode, ConfigNode, ToolNode, GroupNode },
  props: {
    agent: { type: Object, default: () => ({}) },
  },
  setup() {
    const { fitView, onNodesInitialized } = useVueFlow();
    // fit once nodes have real dimensions (running fitView too early can't size them)
    onNodesInitialized(() => fitView({ padding: 0.25 }));
    return { fitView };
  },
  data() {
    return {
      nodes: [],
      edges: [],
    };
  },
  methods: {
    fit() {
      this.fitView({ padding: 0.25 });
    },
    rebuild() {
      const { nodes, edges } = buildGraph(this.agent || {});
      this.nodes = nodes;
      this.edges = edges;
      this.$nextTick(this.fit);
    },
  },
  watch: {
    agent: {
      handler() {
        this.rebuild();
      },
      deep: true,
    },
  },
  created() {
    this.rebuild();
  },
};
</script>
